import { combineReducers } from 'redux'
import login from './login.reducer'
import register from './register.reducer'
import user from './user.reducer'
import pincode from './pincode.reducer'

const authReducers = combineReducers({
  user,
  login,
  pincode,
  register
})

export default authReducers
